import { EntityEnums } from "../enums";

export const languageDict = [
  { label: "empty", value: EntityEnums.Language.Empty },
  { label: "Latin", value: EntityEnums.Language.Latin },
  { label: "English", value: EntityEnums.Language.English },
  { label: "Middle English", value: EntityEnums.Language.MiddleEnglish },
  { label: "Occitan", value: EntityEnums.Language.Occitan },
  { label: "Czech", value: EntityEnums.Language.Czech },
  { label: "Italian", value: EntityEnums.Language.Italian },
  { label: "French", value: EntityEnums.Language.French },
  { label: "German", value: EntityEnums.Language.German },
  { label: "Spanish", value: EntityEnums.Language.Spanish },
  { label: "Hungarian", value: EntityEnums.Language.Hungarian },
];
